// extracted by mini-css-extract-plugin
module.exports = {"FormContainer":"CompanyStoreSettingForm_FormContainer__40j7p","InvalidFeedback":"CompanyStoreSettingForm_InvalidFeedback__LCGbq"};